import { render, staticRenderFns } from "./ActView.vue?vue&type=template&id=27fe6d1c&scoped=true&"
import script from "./ActView.vue?vue&type=script&async=true&lang=js&"
export * from "./ActView.vue?vue&type=script&async=true&lang=js&"
import style0 from "./ActView.vue?vue&type=style&index=0&id=27fe6d1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fe6d1c",
  null
  
)

export default component.exports